import { html, LitElement } from '~/lib/bn-lit-element';
import { captureException } from '@sentry/browser';
import { store, storeActions, userManager, stateStorage } from '~/utility/BinSentry-ui-utility';
import { renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { sessionStyles } from '../styles/session-styles';
import '../common/bn-flash';
import '../common/bn-loading';
import '../common/bn-logo';

// first match wins
const ERROR_SANITIZERS = [
  { pattern: /.*CognitoUserNotFound.*/, sanitized: () => html`
      <p>No BinSentry user was found for your email address.</p>
      <p>Before linking your social account, please sign in with your email address and BinSentry password to
      complete registration.</p>
    ` },
  { pattern: /.*ExternalEmailNotVerified.*/, sanitized: () => html`
      <p>Your email address has not been verified by the social provider.</p>
      <p>Before linking your social account, please verify your email address with the provider.</p>
    ` },
  { pattern: /.*No matching state found in storage.*/, sanitized: (authDomain) => html`
      <p>We don't have a record of you starting this sign-in attempt, so for your security we did not sign you in.</p>
      <p>If you're using a bookmark, save <a href="${window.location.origin}">${window.location.origin}</a>
        as links to ${authDomain} expire after use.</p>
      <p>Please try again using the link below.</p>
    ` },
  { pattern: /.*iat is in the future.*/, sanitized: () => html`
      <p>Your authorization is not yet valid.</p>
      <p>This error is commonly caused by an inaccurate system time on your device.  Please ensure that your device's
        clock shows the correct time and is configured for automatic time synchronization.</p>
      <p>After that, please try again using the link below.</p>
    ` },
  { pattern: /.*exp is in the past.*/, sanitized: () => html`
      <p>Your authorization is no longer valid.</p>
      <p>This error is commonly caused by an inaccurate system time on your device.  Please ensure that your device's
        clock shows the correct time and is configured for automatic time synchronization.</p>
      <p>After that, please try again using the link below.</p>
    ` },
  { pattern: /.*/, sanitized: () => 'An unexpected error occurred.', log: true },
];

const SOCIAL_LINK_SUCCESS_PATTERN = /Already found an entry for username/;

class LoginRedirectPage extends LitElement {
  constructor() {
    super();
    this.state = 'handling';
  }

  static get properties() {
    return {
      authDomain: { type: String, attribute: 'auth-domain' },
      state: { type: String, attribute: false },
      message: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, sessionStyles];
  }

  render() {
    return html`
      <div class="boxes">
        <div class="box">
          <bn-logo></bn-logo>
          <bn-flash id="flash" .banners="${this.message ? [{ content: this.message, type: this.state === 'failed' ? 'critical' : 'success' }] : []}"></bn-flash>
          ${renderIf(this.state === 'handling', html`<bn-loading loading-text="Signing in..."></bn-loading>`)}
          ${renderIf(this.state === 'success', html`<bn-loading loading-text="Sign-in successful, loading..."></bn-loading>`)}
          ${renderIf(this.state === 'failed', html`
            <div>
              <a href="/login">Return to sign-in</a>
            </div>
          `)}
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.onConnected();
  }

  async onConnected() {
    const { path, queryV2 } = stateStorage.popDeepLink() || { path: '/' };
    store.dispatch(storeActions.replaceLocation(path, queryV2));
    this.state = 'success';
    // userManager.signinRedirectCallback()
    //   .then(() => {

    //   })
    //   .catch(err => {
    //     // Cognito gives some extremely specific log-in errors.  We can tailor the error messages in the lambda triggers
    //     // for expected cases, but Cognito still adds a preamble that doesn't look great.
    //     let errorMessage = err.message || `${err}`;

    //     // Cognito's support for automatically linking a social account to a Cognito account as part of first sign-in
    //     // leaves much to be desired.  Notably, when we do the identity linking in a trigger, it will
    //     // error out saying that the account already exists.  In these cases we can just redirect to sign-in which
    //     // will work the second time, and if we restrict specifically to the Google provider, should be completely
    //     // automatic
    //     if (errorMessage.match(SOCIAL_LINK_SUCCESS_PATTERN)) {
    //       this.message = html`
    //         <p>Your Google account was linked successfully.</p>
    //         <p>You will now be redirected to the app.</p>
    //       `;
    //       this.state = 'success';
    //       setTimeout(() => {
    //         userManager.signinRedirect({
    //           extraQueryParams: {
    //             'identity_provider': 'Google',
    //           },
    //         });
    //       }, 3000);
    //       return;
    //     }

    //     for (const { pattern, sanitized, log } of ERROR_SANITIZERS) {
    //       const match = errorMessage.match(pattern);
    //       if (match) {
    //         errorMessage = sanitized(this.authDomain);
    //         if (log) {
    //           captureException(err);
    //         }
    //         break;
    //       }
    //     }

    //     this.message = errorMessage;
    //     this.state = 'failed';
    //   });
  }
}

window.customElements.define('login-redirect-page', LoginRedirectPage);
